import api from "./API";

const extrair = (resposta) => {
  if (resposta?.data?.status === false) {
    throw new Error(resposta?.data?.message || "Falha ao carregar os modelos.");
  }
  return resposta?.data?.records || [];
};

export async function listarModelos(workspaceId) {
  if (!workspaceId) return [];
  const resposta = await api.get(`/task-templates?workspaceId=${workspaceId}`);
  return extrair(resposta);
}

export async function buscarModelo(id) {
  const resposta = await api.get(`/task-templates/${id}`);
  return resposta?.data?.record;
}

export async function criarModelo(workspaceId, modelo) {
  const resposta = await api.post("/task-templates", { ...modelo, workspaceId });
  return resposta?.data?.record;
}

export async function atualizarModelo(id, modelo) {
  const resposta = await api.put(`/task-templates/${id}`, modelo);
  return resposta?.data?.record;
}

export async function removerModelo(id) {
  await api.delete(`/task-templates/${id}`);
}

/** Materializa o modelo como tarefa-pai + subtarefas, com prazos D+N. */
export async function aplicarModelo(id, payload) {
  const resposta = await api.post(`/task-templates/${id}/aplicar`, payload);
  return resposta?.data;
}
